module.exports = __webpack_public_path__ + "files/abcc565cf8a9f6e84d2e189b540618ec.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/symbols.png
// module id = 484
// module chunks = 60